import { render, staticRenderFns } from "./Sincronizacion.vue?vue&type=template&id=9031b170&"
import script from "./Sincronizacion.vue?vue&type=script&lang=js&"
export * from "./Sincronizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports